const initState = {};

const authReducer = (state = initState, action) => state;

export default authReducer;
